import createReducer from 'shared/utils/createReducer';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { LOGOUT } from 'modules/auth/actions/logout';
import { FETCH_CONVERSATION } from 'modules/conference/actions/fetchConversation';
import { STOP_CONSULTATION_LOCAL, STOP_CONSULTATION } from 'modules/conference/actions/stopConsultation';
import { CREATE_CONVERSATION } from 'modules/conference/actions/_newConversationActions/createConversation';
import { UPDATE_CONVERSATION } from 'modules/conference/actions/_newConversationActions/updateConversation';
import { WS_UPDATE_CONVERSATION } from 'modules/conference/actions/_newConversationActions/onConversationUpdate';
import { DECLINE_CONSULTATION } from 'modules/conference/actions/_newConversationActions/conversationLifecircleActions';


const defaultState = {
  requestStatus: requestsStatuses.default,
};

export default createReducer(defaultState, {
  [WS_UPDATE_CONVERSATION]: (state, { payload: { conversationUpdate: { conversationStatus, updatedAt } } }) => ({
    ...state,
    status: conversationStatus,
    updatedAt,
  }),

  [UPDATE_CONVERSATION.success]: (state, { payload: { conversation } }) => ({
    ...state,
    ...conversation,
  }),

  [CREATE_CONVERSATION.success]: (state, { payload: { conversation } }) => ({
    ...state,
    ...conversation,
  }),

  [FETCH_CONVERSATION.success]: (state, { payload: { conversation } }) => ({
    ...state,
    requestStatus: requestsStatuses.success,
    ...conversation,
  }),

  [STOP_CONSULTATION.success]: () => defaultState,
  [STOP_CONSULTATION_LOCAL]: () => defaultState,
  [DECLINE_CONSULTATION]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
  [LOGOUT.failure]: () => defaultState,
});
